import { EDateFormat } from '../../shared/enums/date-format.enum';
import { EDashletPeriod } from '../dashboard/dashboard-timeframes-enums';
import { EDashletType } from '../dashboard/dashlets-enums';
import { TSectionVisibilitySettings } from '../exports/export-body.model';
import { TSavedViewQuickFilters } from '../saved-views/models/saved-view.model';
import { TColumn } from '../site/site-table/columns/column.model';
import { ETimelineTimeframe } from '../site/site-timeline/site-timeline-utils/timeframes-enums';

export type TPreferences = {
  commentOnEnter?: boolean;
  dateFormat?: EDateFormat;
  mapZoomFactor?: number;
  workspaces?: {
    [key: string]: TWorkspacePreferences;
  };
  dashlets?: TDashlets;
  overviewExports?: Omit<TExportPreferences, 'simple'>;
  exports?: TExportPreferences;
  timeline?: TPreferencesTimeline;
  favouriteWorkspaceIds: string[];
  reminderSettings?: TRemindersPreferences;
  /* PS-5548: remove once merged; the signature comes from CurrentUserResponse, not TPreferences */
  signature?: UserSignature;
};

/* PS-5548: replace with Signature from current-user-response-model once merged */
export type UserSignature = {
  signatureId: string;
  name: string;
  role: string;
  createdAtEpochMillis: number;
  svgUrl: string;
};

export type TWorkspacePreferences = {
  exports?: TExportPreferences;
};

export type TWorkspaceLayout = {
  columns?: TColumn[];
  exports?: TExportPreferences;
  collapsedGroups?: string[];
  quickFilters: TSavedViewQuickFilters;
};

export type TRemindersPreferences = {
  alerts: boolean;
  emails: boolean;
  pushNotifications: boolean;
};

export type TDashletSiteRange = {
  accountId?: string;
  workspaceIds?: string[];
  workspacesCosts?: {
    [workspaceId: string]: string[];
  };
  workspaceId?: string;
  listCustomFieldId?: string;
  numericalCustomFieldId?: string;
};

export type TDashlet = {
  period: EDashletPeriod;
  selectedRange?: TDashletSiteRange;
  x: number;
  y: number;
  rows: number;
  cols: number;
  name: EDashletType;
  customName: string;
};

export type TDashlets = {
  data: TDashlet[];
};

export type TPreferencesTimeline = {
  group?: ETimelineGroup;
  timeframe?: ETimelineTimeframe;
};

export enum ETimelineGroup {
  ACCOUNT = 'ACCOUNT',
  SITE = 'SITE',
}

export type TExportPreference = TSectionVisibilitySettings & { pageFormat?: string };

export type TUpdateExportPreference = {
  exports: TExportPreferences;
};

export type TExportPreferences = {
  pdf?: TExportPreference;
  word?: TExportPreference;
  zip?: TExportPreference;
  simple?: TExportPreference;
};
